import { useAuthStore } from '@/store/authStore'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Search, Bell, LogOut } from 'lucide-react'

export function Header() {
  const { partner, logout } = useAuthStore()
  
  return (
    <header className="flex h-16 items-center justify-between border-b border-border bg-card px-6">
      {/* Search */}
      <div className="flex w-96 items-center gap-2">
        <Search className="h-4 w-4 text-muted-foreground" />
        <Input 
          placeholder="Search resources, documentation..." 
          className="h-9 border-0 bg-muted focus-visible:ring-1"
        />
      </div>
      
      {/* Right side */}
      <div className="flex items-center gap-4">
        {/* Admin badge */}
        {partner?.isAdmin && (
          <span className="rounded-full bg-cloudflare-orange/10 px-3 py-1 text-xs font-medium text-cloudflare-orange">
            Admin
          </span>
        )}
        
        {/* Notifications */}
        <Button variant="ghost" size="icon" className="relative">
          <Bell className="h-5 w-5" />
          <span className="absolute right-2 top-2 h-2 w-2 rounded-full bg-cloudflare-orange" />
        </Button>
        
        {/* Logout */}
        <Button variant="ghost" size="icon" onClick={logout}>
          <LogOut className="h-5 w-5" />
        </Button>
      </div>
    </header>
  )
}
